exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "iframe[data-v-724e965b] {\n  width: 100%;\n  height: calc(100vh - 224px);\n  border: 0;\n  display: block;\n}\niframe.hidden-form[data-v-724e965b] {\n  height: calc(100vh - 64px);\n}\n.ntak-dashboard-container[data-v-724e965b] {\n  padding: 25px;\n  padding-bottom: 0;\n  max-width: 600px;\n  margin: auto;\n}\n.ntak-dashboard-container.hidden-form[data-v-724e965b] {\n  display: none;\n}\n", ""]);

// exports
